<div class="height-container">
    <div *ngIf="!showAdmin">
        <nav class="tab-nav">
            <a class="tab-title" *ngFor="let category of categories"
               [ngClass]="{ 'is-active': selectedCategory === category.id }"
               (click)="setSelectedCategory(category.id)">{{ category.categoryShortName }}</a>
        </nav>
        <section class="tab-contents">
            <article class="tab-section is-active">
                <div class="panel" [ngClass]="{ 'panel-red': message.isOutage }" *ngFor="let message of filteredUserMessages">
                    <h5 class="panel-title" (click)="toggleOpen(message)">
                        <span [ngClass]="{ 'icon-ui-checkbox-checked': message.isRead, 'icon-ui-checkbox-unchecked': !message.isRead }"></span>
                        <b>{{ message.systemMessage.systemMessageCategory.categoryName }}:</b> {{ message.systemMessage.title }}
                    </h5>
                    <div class="panel-body" [hidden]="!message.show">
                        <div class="form-group" [innerHtml]="message.systemMessage.message"></div>
                        <div class="form-group" *ngIf="!message.isDismissed">
                            <button class="btn btn-small btn-clear right" (click)="dismissMessage(message); message.show = false;">
                                <span class="icon-ui-close"></span> Dismiss
                            </button>
                        </div>
                    </div>
                </div>
                <div *ngIf="!filteredUserMessages || !filteredUserMessages.length">
                    No messages found.
                </div>
            </article>
        </section>
    </div>
    <div *ngIf="showAdmin">
        <kendo-grid *ngIf="!addEdit"
                    [data]="allSystemMessages"
                    [height]="500"
                    (edit)="editHandler($event)"
                    (remove)="removeHandler($event)"
                    [sortable]="{ allowUnsort: true, mode: 'single' }"
                    [sort]="sort"
                    (sortChange)="sortChange($event)">
            <kendo-grid-column field="systemMessageCategory.categoryShortName" title="Category" width="125px">
                <ng-template kendoGridCellTemplate let-dataItem>{{ dataItem.systemMessageCategory.categoryShortName }}</ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="title" title="Title" width="140px"></kendo-grid-column>
            <kendo-grid-column field="startDate" title="Start" width="90px">
                <ng-template kendoGridCellTemplate let-dataItem>{{ dataItem.startDate | date:'short' }}</ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="expirationDate" title="Expire" width="90px">
                <ng-template kendoGridCellTemplate let-dataItem>{{ dataItem.expirationDate | date:'short' }}</ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="createDate" title="Created" width="85px">
                <ng-template kendoGridCellTemplate let-dataItem>{{ dataItem.createDate | date:'shortDate' }}</ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="message" title="Message">
                <ng-template kendoGridCellTemplate let-dataItem><div [innerHtml]="dataItem.message" style="display: block; max-height: 150px; overflow: auto;"></div></ng-template>
            </kendo-grid-column>
            <kendo-grid-command-column title="Options" width="100px">
                <ng-template kendoGridCellTemplate>
                    <button kendoGridEditCommand>Edit</button><br />
                    <button kendoGridRemoveCommand style="margin-top: 7px;">Remove</button>
                </ng-template>
            </kendo-grid-command-column>
        </kendo-grid>
        <div class="form" *ngIf="addEdit">
            <div class="setting">
                <label for="category">Category</label>
                <select id="category" name="category" [(ngModel)]="currentMessage.systemMessageCategoryId" required>
                    <option *ngFor="let category of dataCategories" [value]="category.id">{{ category.categoryName }}</option>
                </select>
            </div>
            <div class="setting">
                <label for="title">Title</label>
                <input id="title" type="text" name="title" [(ngModel)]="currentMessage.title" required>
            </div>
            <div class="setting">
                <label for="start">Start</label>
                <input id="start" type="datetime-local" name="start"[ngModel]="currentMessage.startDate | date:'yyyy-MM-ddTHH:mm'" (ngModelChange)="currentMessage.startDate = updateDateString($event)" required>
            </div>
            <div class="setting">
                <label for="expire">Expire</label>
                <input id="expire" type="datetime-local" name="expire"[ngModel]="currentMessage.expirationDate | date:'yyyy-MM-ddTHH:mm'" (ngModelChange)="currentMessage.expirationDate = updateDateString($event)">
            </div>
            <div>
                <label for="expire">Message</label>
                <kendo-editor [(value)]="currentMessage.message" style="width: 100%; height: 250px;">
                    <kendo-toolbar [overflow]="true" [style.width.%]="toolbarWidth">
                        <kendo-toolbar-buttongroup>
                            <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                        </kendo-toolbar-buttongroup>
                        <kendo-toolbar-buttongroup>
                            <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
                        </kendo-toolbar-buttongroup>
                        <kendo-toolbar-buttongroup>
                            <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
                            <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
                        </kendo-toolbar-buttongroup>
                    </kendo-toolbar>
                </kendo-editor>
            </div>
        </div>
    </div>
</div>
<div *ngIf="isAdmin" class="admin-btn-area">
    <button *ngIf="showAdmin && !addEdit" class="btn btn-small" (click)="newMessage()">New Message</button>
    <div *ngIf="showAdmin && addEdit" style="display: inline-block;">
        <button class="btn btn-small" (click)="save()">Save</button>
        <button class="btn btn-small" (click)="cancel()" style="margin-left: 5px;">Cancel</button>
    </div>
    <button class="btn btn-small right" (click)="showAdmin = !showAdmin">{{ showAdmin ? 'Back' : 'Admin' }}</button>
</div>
